import { selectorFamily } from 'recoil';
import { allValid } from '@zurich/common/recoil';
import { localPartyCityValidationSelectorFamily, localPartyCountryOnlyAustriaValidationSelectorFamily, localPartyHouseNumberFromValidationSelectorFamily, localPartyHouseNumberToValidationSelectorFamily, localPartyPostalCodeValidationSelectorFamily, localPartyStreetValidationSelectorFamily, } from '../';
export const createSecondPolicyHolderPartyCommunicationFormValidationSelectorFamily = selectorFamily({
    key: 'validation/local/createSecondPolicyHolderPartyCommunicationFormValidationSelectorFamily',
    get: ({ communicationRoleGeo }) => ({ get }) => allValid({
        partyCountry: get(localPartyCountryOnlyAustriaValidationSelectorFamily(communicationRoleGeo)),
        partyPostalCode: get(localPartyPostalCodeValidationSelectorFamily(communicationRoleGeo)),
        partyCity: get(localPartyCityValidationSelectorFamily(communicationRoleGeo)),
        partyStreet: get(localPartyStreetValidationSelectorFamily(communicationRoleGeo)),
        partyHouseNumberFrom: get(localPartyHouseNumberFromValidationSelectorFamily(communicationRoleGeo)),
        partyHouseNumberTo: get(localPartyHouseNumberToValidationSelectorFamily(communicationRoleGeo)),
    }),
});
